import { getCurrentInstance } from 'vue'
import { msg, msgbox, notify } from '@/plugins/message'

/**
 * 在 Composition API 中获取全局弹框实例
 * 模板和 Options API 中可直接使用 this.$msg、this.$msgbox、this.$notify
 */
export function useMessage() {
  const instance = getCurrentInstance()
  if (instance) {
    const { $msg, $msgbox, $notify } = instance.appContext.config.globalProperties
    return {
      msg: ($msg as typeof msg) ?? msg,
      msgbox: ($msgbox as typeof msgbox) ?? msgbox,
      notify: ($notify as typeof notify) ?? notify,
    }
  }
  return { msg, msgbox, notify }
}
